var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.isEditEnabled)?_vm._t("format",function(){return [_vm._v(" "+_vm._s(_vm.value))]},null,{ state: _vm.value }):_c('v-textarea',_vm._g(_vm._b({attrs:{"value":_vm.value}},'v-textarea',_vm.$attrs,false),_vm.$listeners))],2)}
var staticRenderFns = []

export { render, staticRenderFns }